import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

class PrivateRoute extends React.Component {
    constructor(props) {
        super(props);

        this.componentName = "[PrivateRoute.jsx] ";
    }

    render() {
        const { component: Component, ...rest } = this.props;
        console.log(this.componentName + "render [utente]  " + this.props.utente);
        return (

            <Route {...rest} render={(props) => (
                this.props.utente
                    ? <Component {...props} />
                    : <Redirect to={{
                        pathname: '/login',
                        state: { from: props.location }
                    }} />
            )} />

            // FIX ADV360 per il cambio PASSWORD
            /*
            <Route {...rest} render={(props) => (
                this.props.utente
                    ? (this.props.utente.datePasswordModified === null || this.props.utente.datePasswordModified === undefined ?
                        <Redirect to={{ pathname: '/changePassword', state: { from: props.location } }} />
                        :
                        <Component {...props} />
                    )
                    : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )} />*/

        )
    }
}

function mapStateToProps(state) {
    return {
        utente: state.account.utente
    }
}

export default connect(mapStateToProps)(PrivateRoute);
